import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {getBorder, getFontFamily, getFontSize} from 'utils'
import {
  Avatar,
  Button,
  Icon,
  IconVerifiedBadge,
  Paragraph,
} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {TemplateUploadAddCollaboratorProps} from './TemplateUploadAddCollaboratorProps'

const StyledList = styled.ul`
  padding-left: ${convertUnit(20)};
  margin-top: ${convertUnit(2)};
`

const StyledListItem = styled.li`
  font-family: ${getFontFamily('regular')};
  font-size: ${getFontSize('xs')};
  line-height: ${convertUnit(17)};
  padding-left: ${convertUnit(4)};
`

const StyledParagraph = styled(Paragraph)`
  white-space: nowrap;
  text-overflow: ellipsis;
`

const StyledCollabUsernameContainer = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-left: ${convertUnit(12)};
  gap: ${convertUnit(4)};
`

const StyledCollabContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${convertUnit(12)};
  padding-right: unset;
  border: ${({theme}) => getBorder(1.5, 'solid', theme.primary_5)};
  border-radius: ${convertUnit(8)};
`

export default function TemplateUploadAddCollaborator({
  stateCollaborator,
  onAddCollaborator,
  form,
  icon = 'collab-leaf',
}: TemplateUploadAddCollaboratorProps) {
  const collaborator = stateCollaborator && stateCollaborator[0]
  const setCollaborator = stateCollaborator && stateCollaborator[1]
  const {id} = useSelector('user') || {}
  const {translate} = useTranslation()
  const {setValue} = form

  const handleRemoveCollaborator = useCallback(() => {
    setCollaborator && setCollaborator(undefined)
    setValue('collaborator_member_ids', undefined)
  }, [setCollaborator, setValue])

  return (
    <div>
      {collaborator ? (
        <StyledCollabContainer>
          <div>
            <Avatar alt="Avatar" src={collaborator.photo} />
          </div>
          <StyledCollabUsernameContainer>
            <StyledParagraph fontSize="m" fontWeight="medium">
              @{collaborator.username}
            </StyledParagraph>
            {collaborator.creator_status === 'verified' && (
              <IconVerifiedBadge />
            )}
          </StyledCollabUsernameContainer>
          {id !== collaborator.id && (
            <Icon
              type="close"
              color="gray_5"
              size={convertUnit(16)}
              style={{
                marginLeft: 'auto',
                cursor: 'pointer',
                padding: convertUnit(12),
              }}
              onClick={handleRemoveCollaborator}
            />
          )}
        </StyledCollabContainer>
      ) : (
        <Button
          color="primary_5"
          backgroundColor="white_3"
          backgroundHoverColor="white_5"
          label={translate('tree:addCollaborator')}
          leftIcon={
            <Icon
              type={icon}
              color="primary_5"
              size={convertUnit(16)}
              marginRight={convertUnit(8)}
            />
          }
          onClick={onAddCollaborator}
        />
      )}
      <StyledList>
        {[...Array(2)].map((_, index) => (
          <StyledListItem key={index.toString()}>
            {translate('tree:addCollaborator', {context: `${index + 1}`})}
          </StyledListItem>
        ))}
      </StyledList>
    </div>
  )
}
